import { useState, useEffect } from 'react';
import { ProductImage } from '@/components/atoms';
import { cn } from '@/lib/cn';

export function ImageGallery({
  images,
  name,
  selectedIndex,
}: {
  images: string[];
  name: string;
  selectedIndex?: number;
}) {
  const [active, setActive] = useState(selectedIndex ?? 0);
  // Follow the variant-driven image when the parent provides one (1:1 mapping).
  // Manual thumbnail clicks still override until the next variant change.
  useEffect(() => {
    if (selectedIndex != null && selectedIndex >= 0 && selectedIndex < images.length) {
      setActive(selectedIndex);
    }
  }, [selectedIndex, images.length]);
  const list = images.length ? images : [''];

  return (
    <div className="flex flex-col gap-3">
      <ProductImage
        src={list[active]}
        alt={name}
        name={name}
        className="aspect-square w-full rounded-3xl"
        imgClassName="p-8"
      />
      {list.length > 1 && (
        <div className="flex gap-2">
          {list.map((img, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setActive(i)}
              aria-label={`View image ${i + 1}`}
              className={cn(
                'h-16 w-16 overflow-hidden rounded-card border-2 transition-colors',
                i === active ? 'border-leaf-green' : 'border-transparent'
              )}
            >
              <ProductImage src={img} alt={`${name} ${i + 1}`} name={name} className="h-full w-full" imgClassName="p-1" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
